import { useNavigate } from 'react-router-dom';
import logoBrandStarter from '../assets/logo_brandstarter.png';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,500&family=Inter:wght@300;400;500;600;700&display=swap');
  :root { --g:#173B34; --o:#E4572E; --c:#F6F2EC; --d:#222222; --line:#EDE9E2; }

  .lp-page { font-family: 'Inter', sans-serif; background: var(--c); color: var(--d); min-height: 100vh; }

  .lp-nav {
    background: #fff; border-bottom: 1px solid var(--line);
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 24px; height: 68px; position: sticky; top: 0; z-index: 100;
  }
  .lp-nav img { height: 44px; width: auto; cursor: pointer; }
  .lp-nav-back {
    background: transparent; border: 1.5px solid var(--line);
    color: var(--g); border-radius: 999px; padding: 8px 18px;
    font-size: 13px; font-weight: 600; cursor: pointer;
    font-family: 'Inter', sans-serif; display: flex; align-items: center; gap: 6px;
  }

  .lp-hero {
    background: var(--g); padding: 48px 24px;
    text-align: center; position: relative; overflow: hidden;
  }
  .lp-hero::before {
    content: ''; position: absolute; top: -60px; right: -60px;
    width: 240px; height: 240px; border-radius: 50%;
    background: rgba(228,87,46,0.1); pointer-events: none;
  }
  .lp-hero-tag {
    display: inline-flex; align-items: center; gap: 7px;
    background: rgba(228,87,46,0.15); border: 1px solid rgba(228,87,46,0.3);
    border-radius: 999px; padding: 5px 14px;
    font-size: 11px; font-weight: 700; color: var(--o); letter-spacing: .08em;
    margin-bottom: 16px; position: relative; z-index: 2;
  }
  .lp-hero h1 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(26px, 4vw, 40px); color: #fff;
    font-weight: 700; line-height: 1.15; margin-bottom: 12px;
    position: relative; z-index: 2;
  }
  .lp-hero-sub { font-size: 14px; color: rgba(246,242,236,0.5); position: relative; z-index: 2; }

  .lp-tabs {
    display: flex; gap: 4px; background: #fff;
    border-bottom: 1px solid var(--line);
    padding: 12px 24px 0; max-width: 860px; margin: 0 auto;
    position: sticky; top: 68px; z-index: 50;
  }
  .lp-tab {
    padding: 10px 20px; font-size: 14px; font-weight: 600;
    cursor: pointer; border: none; background: transparent;
    font-family: 'Inter', sans-serif; color: #888;
    border-bottom: 2px solid transparent; margin-bottom: -1px;
    transition: all .15s;
  }
  .lp-tab.active { color: var(--g); border-bottom-color: var(--o); }

  .lp-body { max-width: 860px; margin: 0 auto; padding: 40px 24px 80px; }

  .lp-section { margin-bottom: 40px; }
  .lp-section h2 {
    font-family: 'Playfair Display', serif;
    font-size: 20px; color: var(--g); font-weight: 700;
    margin-bottom: 14px; padding-bottom: 10px;
    border-bottom: 2px solid var(--o); display: inline-block;
  }
  .lp-section p { font-size: 15px; color: #444; line-height: 1.75; margin-bottom: 12px; font-weight: 300; }
  .lp-section strong { color: var(--d); font-weight: 600; }
  .lp-section a { color: var(--o); text-decoration: underline; }
  .lp-section ul { padding-left: 20px; margin-bottom: 12px; }
  .lp-section li { font-size: 15px; color: #444; line-height: 1.75; margin-bottom: 6px; }

  .lp-box {
    background: #fff; border: 1px solid var(--line);
    border-radius: 14px; padding: 22px 24px; margin-bottom: 16px;
  }
  .lp-box-title {
    font-size: 13px; font-weight: 700; color: var(--g);
    text-transform: uppercase; letter-spacing: .08em; margin-bottom: 10px;
    display: flex; align-items: center; gap: 8px;
  }
  .lp-box p { margin-bottom: 6px; }

  .lp-table { width: 100%; border-collapse: collapse; margin-bottom: 16px; font-size: 14px; }
  .lp-table th {
    background: var(--g); color: #fff; padding: 10px 14px;
    text-align: left; font-size: 12px; letter-spacing: .06em; text-transform: uppercase;
  }
  .lp-table td { padding: 10px 14px; border-bottom: 1px solid var(--line); color: #444; line-height: 1.55; }
  .lp-table tr:last-child td { border-bottom: none; }
  .lp-table tr:nth-child(even) td { background: #FDFCFA; }

  .lp-highlight {
    background: rgba(23,59,52,0.06); border-left: 3px solid var(--g);
    border-radius: 0 12px 12px 0; padding: 16px 20px; margin-bottom: 16px;
    font-size: 14.5px; color: #333; line-height: 1.65;
  }
  .lp-highlight.orange { background: rgba(228,87,46,0.06); border-left-color: var(--o); }

  .lp-date {
    text-align: center; font-size: 13px; color: #B0A898; margin-top: 48px;
    padding-top: 20px; border-top: 1px solid var(--line);
  }

  @media(max-width:640px) {
    .lp-hero { padding: 36px 16px; }
    .lp-body { padding: 28px 16px 60px; }
    .lp-tabs { padding: 12px 16px 0; overflow-x: auto; }
    .lp-tab { white-space: nowrap; font-size: 13px; padding: 10px 14px; }
    .lp-table { font-size: 12px; }
    .lp-table th, .lp-table td { padding: 8px 10px; }
  }
`;

function MentionsLegales() {
  return (
    <div>
      <div className="lp-section">
        <h2>Éditeur du site</h2>
        <div className="lp-box">
          <div className="lp-box-title">🏢 Informations légales</div>
          <p><strong>Raison sociale :</strong> Stratvente</p>
          <p><strong>Représentant légal :</strong> Dany Dassonville</p>
          <p><strong>Statut :</strong> Micro-entrepreneur</p>
          <p><strong>SIRET :</strong> 510 743 578 00021</p>
          <p><strong>Adresse :</strong> 212 rue Jacques Brel, 59553 Cuincy, France</p>
          <p><strong>Email :</strong> <a href="mailto:commercial@stratvente.com">commercial@stratvente.com</a></p>
        </div>
      </div>

      <div className="lp-section">
        <h2>Hébergement</h2>
        <div className="lp-box">
          <div className="lp-box-title">🖥️ Hébergeur</div>
          <p><strong>Société :</strong> Hostinger International Ltd.</p>
          <p><strong>Adresse :</strong> 61 Lordou Vironos Street, 6023 Larnaca, Chypre</p>
          <p><strong>Site :</strong> <a href="https://www.hostinger.fr" target="_blank" rel="noreferrer">www.hostinger.fr</a></p>
        </div>
        <p>Les serveurs hébergeant BrandStarter sont localisés au sein de l'Union Européenne, dans le respect du RGPD.</p>
      </div>

      <div className="lp-section">
        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des contenus présents sur BrandStarter (textes, graphismes, logotypes, images, sons, vidéos, architecture du site) est la propriété exclusive de Stratvente, sauf mention contraire explicite.</p>
        <p>Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l'accord exprès par écrit de Stratvente.</p>
        <div className="lp-highlight">
          Les contenus de marque générés par les utilisateurs via BrandStarter (positionnement, persona, charte visuelle…) leur appartiennent intégralement. Stratvente ne revendique aucun droit sur ces productions.
        </div>
      </div>

      <div className="lp-section">
        <h2>Responsabilité</h2>
        <p>BrandStarter est une plateforme d'accompagnement guidé par intelligence artificielle. Les recommandations produites constituent une aide à la réflexion stratégique et non un conseil professionnel engageant la responsabilité de Stratvente.</p>
        <p>Stratvente s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur BrandStarter, dont elle se réserve le droit de corriger le contenu à tout moment.</p>
      </div>

      <div className="lp-section">
        <h2>Droit applicable</h2>
        <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
      </div>

      <div className="lp-date">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
    </div>
  );
}

function PolitiqueConfidentialite() {
  return (
    <div>
      <div className="lp-highlight">
        <strong>En résumé :</strong> BrandStarter collecte uniquement les données nécessaires à son fonctionnement. Tes données de marque t'appartiennent. Tu peux les exporter ou les supprimer à tout moment. Nous ne vendons aucune donnée personnelle.
      </div>

      <div className="lp-section">
        <h2>Responsable du traitement</h2>
        <p><strong>Stratvente</strong>, Dany Dassonville, micro-entrepreneur</p>
        <p>SIRET : 510 743 578 00021, 212 rue Jacques Brel, 59553 Cuincy</p>
        <p>Contact DPO : <a href="mailto:commercial@stratvente.com">commercial@stratvente.com</a></p>
      </div>

      <div className="lp-section">
        <h2>Données collectées</h2>
        <table className="lp-table">
          <thead>
            <tr>
              <th>Donnée</th>
              <th>Finalité</th>
              <th>Base légale</th>
              <th>Durée</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Prénom, nom, email</strong></td>
              <td>Création et gestion du compte utilisateur</td>
              <td>Exécution du contrat</td>
              <td>Durée du compte + 30 jours</td>
            </tr>
            <tr>
              <td><strong>Mot de passe (hashé)</strong></td>
              <td>Authentification sécurisée</td>
              <td>Exécution du contrat</td>
              <td>Durée du compte</td>
            </tr>
            <tr>
              <td><strong>Date d'inscription</strong></td>
              <td>Gestion de la période d'accès gratuit</td>
              <td>Exécution du contrat</td>
              <td>Durée du compte + 30 jours</td>
            </tr>
            <tr>
              <td><strong>Réponses aux modules</strong></td>
              <td>Génération de la charte de marque</td>
              <td>Exécution du contrat</td>
              <td>Durée du compte + 30 jours</td>
            </tr>
            <tr>
              <td><strong>Statut et progression</strong></td>
              <td>Suivi du parcours et gestion admin</td>
              <td>Intérêt légitime</td>
              <td>Durée du compte + 30 jours</td>
            </tr>
            <tr>
              <td><strong>Journal des actions admin</strong></td>
              <td>Traçabilité et sécurité</td>
              <td>Obligation légale</td>
              <td>12 mois</td>
            </tr>
          </tbody>
        </table>
        <p>Nous ne collectons <strong>aucune donnée de navigation</strong> (cookies tiers, trackers publicitaires, analytics tiers). BrandStarter est une plateforme sans publicité.</p>
      </div>

      <div className="lp-section">
        <h2>Sous-traitants et transferts</h2>
        <table className="lp-table">
          <thead>
            <tr>
              <th>Sous-traitant</th>
              <th>Rôle</th>
              <th>Pays</th>
              <th>Garanties</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Hostinger</strong></td>
              <td>Hébergement serveur</td>
              <td>UE (Lituanie)</td>
              <td>Conforme RGPD</td>
            </tr>
            <tr>
              <td><strong>Notion Labs</strong></td>
              <td>Stockage des données utilisateurs</td>
              <td>USA</td>
              <td>DPF UE-États-Unis</td>
            </tr>
            <tr>
              <td><strong>Anthropic</strong></td>
              <td>Traitement IA des réponses modules</td>
              <td>USA</td>
              <td>DPF UE-États-Unis + clauses contractuelles</td>
            </tr>
          </tbody>
        </table>
        <div className="lp-highlight orange">
          <strong>Important :</strong> Les réponses que tu fournis aux modules BrandStarter sont transmises à Anthropic pour générer les synthèses IA. Ces données ne sont pas utilisées pour entraîner les modèles d'Anthropic, conformément à leur politique de confidentialité pour les clients API.
        </div>
      </div>

      <div className="lp-section">
        <h2>Tes droits</h2>
        <p>Conformément au RGPD (Règlement UE 2016/679), tu disposes des droits suivants :</p>
        <div className="lp-box">
          {[
            ['🔍', 'Droit d\'accès', 'Obtenir une copie de toutes tes données personnelles détenues par BrandStarter.'],
            ['✏️', 'Droit de rectification', 'Corriger des données inexactes te concernant.'],
            ['🗑️', 'Droit à l\'effacement', 'Demander la suppression de ton compte et de toutes tes données.'],
            ['📦', 'Droit à la portabilité', 'Recevoir tes données dans un format structuré et lisible.'],
            ['🚫', 'Droit d\'opposition', 'T\'opposer à certains traitements basés sur l\'intérêt légitime.'],
            ['⏸️', 'Droit à la limitation', 'Demander la suspension temporaire d\'un traitement.'],
          ].map(([ico, titre, desc], i) => (
            <div key={i} style={{ display: 'flex', gap: 12, marginBottom: i < 5 ? 14 : 0 }}>
              <span style={{ fontSize: 18, flexShrink: 0 }}>{ico}</span>
              <div>
                <strong style={{ display: 'block', color: '#173B34', fontSize: 14, marginBottom: 3 }}>{titre}</strong>
                <span style={{ fontSize: 14, color: '#555', lineHeight: 1.6 }}>{desc}</span>
              </div>
            </div>
          ))}
        </div>
        <p>Pour exercer tes droits, envoie un email à <a href="mailto:commercial@stratvente.com">commercial@stratvente.com</a> avec l'objet "Droits RGPD". Nous répondons dans un délai de <strong>30 jours maximum</strong>.</p>
        <p>Tu peux également exercer tes droits directement depuis ton espace profil dans l'application (export et suppression de compte).</p>
        <p>En cas de litige non résolu, tu peux saisir la <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">CNIL</a> (Commission Nationale de l'Informatique et des Libertés).</p>
      </div>

      <div className="lp-section">
        <h2>Sécurité des données</h2>
        <ul>
          <li>Les mots de passe sont <strong>hashés via bcrypt</strong>, jamais stockés en clair</li>
          <li>Les communications entre ton navigateur et nos serveurs sont chiffrées via <strong>HTTPS/TLS</strong></li>
          <li>L'accès aux données est limité au seul administrateur de la plateforme (Dany Dassonville)</li>
          <li>Les tokens d'authentification JWT expirent automatiquement</li>
          <li>Aucune donnée de carte bancaire n'est collectée sur BrandStarter</li>
        </ul>
      </div>

      <div className="lp-section">
        <h2>Cookies</h2>
        <p>BrandStarter utilise uniquement des <strong>cookies techniques strictement nécessaires</strong> au fonctionnement de l'application (maintien de la session de connexion).</p>
        <p>Aucun cookie publicitaire, analytique tiers ou de traçage n'est déposé. Aucun bandeau de consentement aux cookies n'est donc requis.</p>
      </div>

      <div className="lp-section">
        <h2>Durée de conservation</h2>
        <p>Tes données sont conservées pendant la durée d'activité de ton compte, puis supprimées dans un délai de <strong>30 jours</strong> suivant la fermeture du compte ou la réception d'une demande de suppression.</p>
        <p>Le journal des actions d'administration est conservé <strong>12 mois</strong> à des fins de sécurité, puis supprimé.</p>
      </div>

      <div className="lp-section">
        <h2>Modifications</h2>
        <p>Stratvente se réserve le droit de modifier la présente politique de confidentialité. En cas de modification substantielle, tu seras informé par email ou via une notification dans l'application.</p>
      </div>

      <div className="lp-date">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
    </div>
  );
}

export function LegalPage({ page = 'mentions' }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState(page);

  return (
    <>
      <style>{CSS}</style>
      <div className="lp-page">

        {/* NAV */}
        <nav className="lp-nav">
          <img src={logoBrandStarter} alt="BrandStarter" onClick={() => navigate('/')}/>
          <button className="lp-nav-back" onClick={() => navigate(-1)}>
            ← Retour
          </button>
        </nav>

        {/* HERO */}
        <div className="lp-hero">
          <div className="lp-hero-tag">Informations légales</div>
          <h1>Transparence & conformité</h1>
          <p className="lp-hero-sub">BrandStarter by Stratvente · Dany Dassonville</p>
        </div>

        {/* TABS */}
        <div className="lp-tabs">
          <button
            className={`lp-tab ${activeTab === 'mentions' ? 'active' : ''}`}
            onClick={() => setActiveTab('mentions')}
          >
            Mentions légales
          </button>
          <button
            className={`lp-tab ${activeTab === 'confidentialite' ? 'active' : ''}`}
            onClick={() => setActiveTab('confidentialite')}
          >
            Politique de confidentialité
          </button>
        </div>

        {/* CONTENU */}
        <div className="lp-body">
          {activeTab === 'mentions' ? <MentionsLegales /> : <PolitiqueConfidentialite />}
        </div>

      </div>
    </>
  );
}

// Import React pour useState
import React from 'react';
